/**
 * Convert a percentage value (e.g., 5) to decimal format (e.g., 0.05) for API storage.
 * If value is already in decimal format (≤ 1), it returns as-is.
 */
export const toDecimal = (value: number | null): number | null => {
  if (value === null || value === undefined) return null;
  return value > 1 ? value / 100 : value;
};

/**
 * Convert a decimal value (e.g., 0.05) to percentage format (e.g., 5) for display.
 * If value is already in percentage format (> 1), it returns as-is.
 */
export const toPercentage = (value: number | null): number | null => {
  if (value === null || value === undefined) return null;
  return value <= 1 ? value * 100 : value;
};
